import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateAttendanceSheet } from '../services/api';
import { useLanguage } from '../LanguageContext';

function AttendanceSheetPage() {
  const navigate = useNavigate();
  const { language, setLanguage, t } = useLanguage();
  const [month, setMonth] = useState(() => {
    const next = new Date();
    next.setMonth(next.getMonth() + 1);
    return next.toISOString().slice(0, 7);
  });
  const [studentFilter, setStudentFilter] = useState('approved');
  const [loading, setLoading] = useState(false);
  const [showAttendanceMenu, setShowAttendanceMenu] = useState(true);
  const username = localStorage.getItem('username');

  const handleGenerate = async () => {
    setLoading(true);
    try {
      const response = await generateAttendanceSheet(month, studentFilter);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `attendance-${month}.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert('Failed to generate attendance sheet');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div style={{display: 'flex', minHeight: '100vh'}}>
      <div style={{width: '250px', backgroundColor: '#f8f9fa', borderRight: '1px solid #dee2e6', padding: '20px'}}>
        <div style={{marginBottom: '30px', textAlign: 'center'}}>
          <img src="/misk_logo.png" alt="MISK Logo" style={{height: '60px'}} />
        </div>
        <nav>
          <div 
            style={{padding: '12px', cursor: 'pointer', borderRadius: '5px', color: '#2d5f3f', fontWeight: '500', marginBottom: '10px'}}
            onClick={() => navigate('/dashboard')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            📊 Dashboard
          </div>
          <div 
            style={{padding: '12px', cursor: 'pointer', borderRadius: '5px', color: '#2d5f3f', fontWeight: '500', marginBottom: '10px'}}
            onClick={() => navigate('/dashboard')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            👥 Students
          </div>
          <div style={{marginBottom: '10px'}}>
            <div 
              style={{padding: '12px', cursor: 'pointer', borderRadius: '5px', backgroundColor: showAttendanceMenu ? '#e8f5e9' : 'transparent', color: '#2d5f3f', fontWeight: '500'}}
              onClick={() => setShowAttendanceMenu(!showAttendanceMenu)}
            >
              📋 Attendance {showAttendanceMenu ? '▼' : '▶'}
            </div>
            {showAttendanceMenu && (
              <>
                <div 
                  style={{paddingLeft: '30px', paddingTop: '8px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', backgroundColor: '#e8f5e9', color: '#555', fontWeight: '500'}}
                >
                  Generate Sheet
                </div>
                <div 
                  style={{paddingLeft: '30px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', color: '#555'}}
                  onClick={() => navigate('/upload-attendance')}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Upload Offline Sheet
                </div>
                <div 
                  style={{paddingLeft: '30px', cursor: 'pointer', padding: '8px 8px 8px 30px', borderRadius: '5px', color: '#555'}}
                  onClick={() => navigate('/online-attendance')}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#e8f5e9'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                >
                  Online Attendance
                </div>
              </>
            )}
          </div>
        </nav>
      </div>

      <div style={{flex: 1}}>
        <div className="container">
          <div className="header">
            <h1 style={{margin: 0}}>Generate Attendance Sheet</h1>
            <div style={{display: 'flex', alignItems: 'center', gap: '15px'}}>
              <select value={language} onChange={(e) => setLanguage(e.target.value)} className="lang-select">
                <option value="en">English</option>
                <option value="ta">தமிழ்</option>
                <option value="ar">العربية</option>
              </select>
              <span>Welcome, {username}</span>
              <button className="btn btn-logout" onClick={handleLogout}>{t('logout')}</button>
            </div>
          </div>

      <div className="card" style={{maxWidth: '600px', margin: '0 auto'}}>
        <h2 style={{marginBottom: '30px'}}>Attendance Sheet Generator</h2>
        
        <div className="form-group">
          <label>Select Month *</label>
          <input 
            type="month" 
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            required
          />
        </div>

        <div className="form-group" style={{marginTop: '20px'}}>
          <label>Student Filter *</label>
          <div style={{display: 'flex', gap: '20px', marginTop: '10px'}}>
            <label style={{cursor: 'pointer'}}>
              <input 
                type="radio" 
                value="approved"
                checked={studentFilter === 'approved'}
                onChange={(e) => setStudentFilter(e.target.value)}
              /> Approved Students Only
            </label>
            <label style={{cursor: 'pointer'}}>
              <input 
                type="radio" 
                value="all"
                checked={studentFilter === 'all'}
                onChange={(e) => setStudentFilter(e.target.value)}
              /> All Students
            </label>
          </div>
        </div>

        <button 
          className="btn btn-primary" 
          onClick={handleGenerate}
          disabled={loading}
          style={{width: '100%', marginTop: '30px'}}
        >
          {loading ? 'Generating...' : 'Generate PDF'}
        </button>
      </div>
        </div>
      </div>
    </div>
  );
}

export default AttendanceSheetPage;
